import styled, { css } from "styled-components";
import * as mediaQuery from "components/MediaQuery";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

export const Row = styled.div<{ isAdmin?: boolean; ellipsis?: boolean }>`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  word-break: break-all;
  ${({ isAdmin, theme }) =>
    isAdmin &&
    css`
      color: ${theme.COLORS.SELECTED};
    `}
  ${({ ellipsis }) =>
    ellipsis &&
    css`
      white-space: normal;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      line-clamp: 1;
      overflow: hidden;
    `}
`;

interface Props {
  isDeleted?: boolean;
}

export const Text = styled.div<Props>`
  color: ${(props) =>
    props.isDeleted ? props.theme.COLORS.BUTTONS1 : props.theme.COLORS.WHITE};
`;
// export const Icon = styled.div`
//   width: 20px;
//   img {
//     width: 100%;
//   }
// `;

export const EditUserCompany = styled.div`
  padding: 10px 0;

  .common-modal-input {
    padding: 6px 0;
  }
  .modal-input-label-title {
    font-size: ${calcRem(14)};
    margin-bottom: -5px;
    ${mediaQuery.isMobile} {
      margin-bottom: 0;
    }
  }
`;

export const ReceiveTitle = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 4px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-weight: 500;

  button {
    position: relative;
    color: ${({ theme }) => theme.COLORS.WHITE};
    ${FLEX.FlexCenterCenter};

    .bubble-container {
      left: -8px;
      transform: unset;
    }
  }
`;

export const UserGroups = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  span {
    white-space: normal;
    word-break: break-all;
  }
  ${mediaQuery.isMobile} {
    flex-direction: column;
  }
`;

export const TemporaryUser = styled.span`
  padding: 4px 6px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.COLORS.SELECTED}10;
  color: ${({ theme }) => theme.COLORS.SELECTED};
  ${FLEX.FlexStartCenter};
  gap: 2px;
  cursor: pointer;
  font-size: ${calcRem(12)};
  line-height: ${calcRem(15)};
`;
